<template>
  <div>
    <el-table v-if="showType===1" size="mini" :data="tableList" border height="450"
              style="border-radius: 10px;margin-top: 10px;width: 820px">
      <el-table-column label="文件名称" prop="name">
        <template #default="{ row }">
          <div class="file-name-wrapper flex align-center">
            <svg-icon style="font-size: 30px" :icon-class="row.type"/>
            <div style="margin-left: 10px;font-size: 12px">{{row.name}}</div>
          </div>
          <div class="file-tools">
            <el-button type="text" icon="el-icon-download"></el-button>
            <el-button type="text" icon="el-icon-edit"></el-button>
            <el-button type="text" icon="el-icon-delete"></el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="类型" prop="type" width="130"/>
      <el-table-column label="大小" prop="size" width="110"/>
      <el-table-column label="创建时间" prop="createTime" width="160"/>
    </el-table>
    <el-row v-if="showType === 2" :gutter="20">
      <el-col :span="3" v-for="(item, index) in tableList" :key="index">
        <!-- 下拉菜单 -->
        <el-dropdown style="text-align: right" placement="bottom-start" class="setting-dropdown">
      <span class="setting-icon">
        <i class="el-icon-setting"></i>
      </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item >
              <span class="el-icon-download"></span>
              <span style="font-size: 13px;margin-left: 8px">下载</span>
            </el-dropdown-item>
            <el-dropdown-item>
              <span class="el-icon-edit"></span>
              <span style="font-size: 13px;margin-left: 8px">编辑</span>
            </el-dropdown-item>
            <el-dropdown-item>
              <span class="el-icon-delete" style="color: red"></span>
              <span style="font-size: 13px;margin-left: 8px;">删除</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="file-item" :title="item.size">
          <svg-icon style="font-size: 36px" :icon-class="item.type" />
          <p style="font-size: 12px" :title="item.name+'.'+item.type">
            {{ item.name.length > 5 ? item.name.slice(0, 5) + '...' : item.name }}
          </p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "FileTable",
  props: {
    showType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      tableList: [
        { name: "可执行程序", type: "exe", createTime: "2025-01-01 10:00:00", size: "2.4MB" },
        { name: "项目文件夹", type: "folder", createTime: "2025-01-02 09:30:00", size: "-" },
        { name: "风景照片", type: "image", createTime: "2025-01-03 14:20:00", size: "3.8MB" },
        { name: "背景音乐", type: "music", createTime: "2025-01-04 16:10:00", size: "8.2MB" },
        { name: "工作文档", type: "word", createTime: "2025-01-05 11:00:00", size: "1.1MB" },
        { name: "说明书", type: "pdf", createTime: "2025-01-06 15:30:00", size: "5.6MB" },
        { name: "压缩包", type: "rar", createTime: "2025-01-07 13:40:00", size: "45MB" },
        { name: "笔记文本", type: "txt", createTime: "2025-01-08 10:20:00", size: "2KB" },
        { name: "宣传视频", type: "video", createTime: "2025-01-09 17:00:00", size: "128MB" },
        { name: "说明书", type: "pdf", createTime: "2025-01-06 15:30:00", size: "5.6MB" },
        { name: "压缩包", type: "rar", createTime: "2025-01-07 13:40:00", size: "45MB" },
        { name: "笔记文本", type: "txt", createTime: "2025-01-08 10:20:00", size: "2KB" },
        { name: "宣传视频", type: "video", createTime: "2025-01-09 17:00:00", size: "128MB" }
      ]
    }
  },
  methods:{
    authentication(){

    },
    /**
     * 根据文件夹id查询文件夹内容，
     */
    checkFolderContentById(){

    }
  }
}
</script>

<style scoped>
.file-table{
  border-radius: 10px;
  padding: 6px 0px 10px 6px;
}
.file-name-wrapper {
  position: relative;
  width: 100%;
}
/* 操作按钮默认隐藏 */
.file-tools {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: none;
}

/* 鼠标悬停当前行时，显示操作按钮 */
.el-table__row:hover .file-tools {
  display: block;
}
.el-row{
  text-align: center;
  margin-top: 14px;
}
.el-col{
  border-radius: 16px;
  padding:20px 4px 4px 4px;
  position: relative;
  box-sizing: border-box;
}
.el-col:hover{
  background-color: #F5F7FA;
}
.el-dropdown-item {
  font-size: 10px;
}
/* 2. 下拉图标容器：绝对定位到右上角，默认隐藏 */
.setting-dropdown {
  position: absolute;
  top: 10px;
  right: 10px;
  display: none; /* 默认隐藏 */
}
.el-col:hover .setting-dropdown {
  display: block;
}
/* 可选：优化设置图标大小、间距 */
.setting-icon {
  font-size: 15px;
  cursor: pointer;
}
</style>